import { Enumify } from "enumify";
export class PageJumpType extends Enumify {
  static back = new PageJumpType("back", "后退");
  static forward = new PageJumpType("forward", "前进");
  static _ = PageJumpType.closeEnum();
  constructor(value, desc) {
    super();
    this.value = value;
    this.desc = desc;
  }
  static getByValue(value) {
    return PageJumpType.enumValues.find((item) => item.value === value);
  }
  static getOptions() {
    return PageJumpType.enumValues.map((item) => {
      return {
        label: item.desc,
        value: item.value,
      };
    });
  }
}
